import { API_URL as ENDPOINT } from "../config/env";

/**
 * Sube el Excel del presupuesto y lo guarda en la base.
 *
 * Se usa XMLHttpRequest (no fetch) porque sólo XHR avisa el avance de la
 * subida, y en archivos grandes "Leyendo el Excel..." sin barra de progreso
 * daba la impresión de que se había quedado colgado.
 */
export async function PresupuestoImportar(proyectoId, archivo, token, onProgreso) {
  const datos = new FormData();
  datos.append("proyectos_id", proyectoId);
  datos.append("archivo", archivo);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${ENDPOINT}PresupuestoImportar`);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.setRequestHeader("Authorization", `${token}`);

    if (onProgreso) {
      xhr.upload.onprogress = (evento) => {
        if (evento.lengthComputable) {
          onProgreso(Math.round((evento.loaded / evento.total) * 100));
        }
      };
    }

    xhr.onload = () => {
      try {
        resolve(JSON.parse(xhr.responseText));
      } catch (e) {
        reject(new Error("El servidor no respondió correctamente."));
      }
    };
    xhr.onerror = () => reject(new Error("No se pudo conectar con el servidor."));

    xhr.send(datos);
  });
}

/**
 * Descarga el Excel del presupuesto.
 *
 * Se baja con fetch y no con window.open porque la ruta pide el token en el
 * header, y una ventana nueva no lo lleva.
 */
export async function PresupuestoExportar(proyectoId, token) {
  const respuesta = await fetch(`${ENDPOINT}PresupuestoExportar/${proyectoId}`, {
    headers: { Authorization: `${token}` },
  });

  if (!respuesta.ok) {
    let mensaje = "No se pudo generar el Excel";
    try {
      const error = await respuesta.json();
      mensaje = error.message || mensaje;
    } catch (e) {
      // La respuesta no era JSON: se queda el mensaje genérico.
    }
    throw new Error(mensaje);
  }

  const nombre = (respuesta.headers.get("content-disposition") || "")
    .split("filename=")
    .pop()
    .replace(/["';]/g, "")
    .trim();

  const blob = await respuesta.blob();
  const url = window.URL.createObjectURL(blob);
  const enlace = document.createElement("a");

  enlace.href = url;
  enlace.download = nombre || "presupuesto.xlsx";
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  window.URL.revokeObjectURL(url);
}

/** Los números ya calculados de la portada, el esquema y el flujo. */
export async function PresupuestoResumen(proyectoId, token) {
  return fetch(`${ENDPOINT}PresupuestoResumen/${proyectoId}`, {
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: `${token}`,
    },
  }).then((res) => res.json());
}
